import type { AuditFinding } from '../../../api/auditFindings'
import { SeverityPill } from './SeverityPill'

/**
 * Constatarile unei rulari, cele mai grave intai - tabelul din fotografie
 * (`snapshot.php`, sectiunea "Findings"): Severity / What is wrong / Where /
 * Check. Numai de citit: aici randurile sunt hartiile de lucru ale unei
 * fotografii datate, iar starea si termenul lor se misca in registru.
 *
 * Randurile vin gata ordonate de pe server (`Findings::forRun`); tabelul nu
 * le mai sorteaza, ca sa nu ajunga sa spuna altceva decat documentul.
 */
export function FindingsTable({ rows }: { rows: AuditFinding[] }) {
  if (rows.length === 0) return null

  return (
    <div className="adm-card od-audit-runs">
      <table className="table od-audit-table">
        <thead>
          <tr>
            <th className="od-audit-th-area">Severity</th>
            <th>What is wrong</th>
            <th>Where</th>
            <th>Check</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((one) => (
            <tr key={one.ID}>
              <td className="adm-nowrap">
                <SeverityPill severity={one.severity} />
              </td>
              <td>
                <strong>{one.title}</strong>
                {one.evidence.trim() !== '' ? <div className="adm-muted">{one.evidence}</div> : null}
              </td>
              <td className="adm-muted">{one.machines}</td>
              <td className="adm-nowrap adm-muted">{one.check_id}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
